import { Box, Checkbox, Grid, Stack, Typography } from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { TakingOptions, UpdateMedicine, ViewMedicine } from '../common/medications.component'
import stylesheet from '../detail-container.stylesheet'

interface IProps {
  medicineInfo: any
  outerSubmit: any
  mapState?: Map<string, any>
  classes: ClassNameMap
}

const DetailPrgMedComponent: React.FC<IProps> = ({ medicineInfo, outerSubmit, mapState, classes }) => {
  const uiResource = useSelector((state: RootState) => state.metaData.metadata)
  const initialValues = {
    medicineData: { id: '', name: '' },
    dose: medicineInfo.c_schedule?.dose || '',
    num_units: medicineInfo.pu_order?.num_units || '',
    unit: medicineInfo.pu_order?.unit || '',
    route: medicineInfo.pu_order?.route || '',
    frequency: medicineInfo.pu_order?.frequency || '',
    prescription_taken: medicineInfo.prescription_taken || false,
    schedule_name: medicineInfo?.c_schedule?.name || '',
    intake_regularity: medicineInfo?.intake_regularity || '',
    dosage_info: medicineInfo?.dosage_info || '',
    disallow_substitution: medicineInfo?.disallow_substitution,
    current_dose_start_date: medicineInfo?.current_dose_start_date || null
  }
  // The dialog unmounts inactive tabs, so this form remounts when the user
  // switches tabs. Rehydrate from the shared mapState (populated by the effect
  // below on every edit) so in-progress edits survive a tab switch instead of
  // resetting to medicineInfo. Falls back to medicineInfo on first mount.
  const persistedValues = mapState?.get('values')
  const [values, setValues] = useState((persistedValues ?? initialValues) as any)
  const [isTaking, setIsTaking] = useState(persistedValues?.intake_regularity ?? medicineInfo?.intake_regularity)
  const [dosageInfo, setDosageInfo] = useState(persistedValues?.dosage_info ?? medicineInfo?.dosage_info ?? [] as any)

  const handleInputChange = (e: any) => {
    if (e.target.name === 'current_dose_start_date') {
      const ts = e.target.value ? Math.floor(new Date(e.target.value + 'T12:00:00').getTime() / 1000) : null
      setValues({ ...values, current_dose_start_date: ts })
      return
    }
    setValues({
      ...values,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
    })
  }

  // Handle frequency changes from the Select dropdown
  const handleSigsChange = (e: any) => {
    const newValue = e.target.value
    console.log('[DetailPrgMed] handleSigsChange:', { name: e.target.name, value: newValue })
    setValues((prevValues: any) => ({
      ...prevValues,
      [e.target.name]: newValue
    }))
  }

  const handleDosageUpdate = (e: any) => {
    const name = e.target.name

    if (name === 'medication_timings') {
      let medicationTimings: string = e.target.value
      setDosageInfo([{ medicationTimings }])
      setValues({ ...values, 'dosage_info': [{ medicationTimings }] })
    }
  }

  useEffect(() => {
    outerSubmit('values', values)
  }, [values])

  const onBtnChange = (_input: string) => {
    setValues({ ...values, 'intake_regularity': _input })
    setIsTaking(_input === 'not taking' ? false : true)
  }

  return (
    <Box p={1}>
      <Box mb={2} pl={1}>
        <Grid container className={classes.medicationsBoxDisplay} direction="row" justifyContent="space-between">
          <Grid item xs={10}>
            <Grid container direction="row" justifyContent={"flex-start"} alignItems={"center"}>
              <Grid item xs={12} className={classes.checkBoxShadow}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Checkbox
                    onChange={handleInputChange}
                    checked={values.prescription_taken}
                    name="prescription_taken"
                    color="default"
                    sx={{ padding: '0.2rem 0rem 0.2rem 0.5rem', transform: 'scale(0.8)' }}
                    inputProps={{ "aria-label": "checkbox with default color" }}
                    size="small"
                  />
                  <Typography variant="subtitle2" color="textSecondary" className={classes.textLabel} sx={{ paddingLeft: '0rem !important' }}>
                    Taken as needed
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Box pt={2} pb={2}>
                  <TakingOptions
                    isPrgMed={true}
                    options={['taking', 'not taking', 'taking differently']}
                    onBtnChange={onBtnChange}
                    currentOption={values?.intake_regularity}
                    classes={classes}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                {isTaking ?
                  <UpdateMedicine
                    isPrgMed={true}
                    medicineInfo={medicineInfo}
                    dosageInfo={dosageInfo}
                    handleDosageUpdate={handleDosageUpdate}
                    handleSigsChange={handleSigsChange}
                    values={values}
                    classes={classes}
                    uiResource={uiResource}
                    handleInputChange={handleInputChange}
                  /> :
                  <ViewMedicine
                    uiResource={uiResource}
                    medicineInfo={medicineInfo}
                    dosageInfo={dosageInfo}
                    classes={classes}
                  />
                }
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default withStyles(stylesheet)(DetailPrgMedComponent)
